export default __webpack_public_path__ + "img/6534f9485ffef9d46524075a775da9ed.svg";